<kt-base-modal [title]="'Shift Detail'" *ngIf="isModal">
  <div modal-body>
    <b *ngIf="swap">
      From Shift
    </b>
    <ng-template [ngTemplateOutlet]="detail"></ng-template>
    <b *ngIf="swap">
      To Shift
    </b>
    <ng-template *ngIf="swap" [ngTemplateOutlet]="toShiftInfo"></ng-template>

    <div class="modal-footer" *ngIf="showClaimShiftButton">
      <button type="button" class="btn btn-brand false" (click)="activeModal.close({claim: true})">Claim Shift</button>
    </div>
  </div>

</kt-base-modal>

<div>
  <ng-template *ngIf="!isModal" [ngTemplateOutlet]="detail"></ng-template>
</div>

<ng-template #detail>
  <div>
    <div class="row">
      <!-- Area -->
      <div class="form-group w-100 col-12">
        <label>{{masterBusinessLabel.Area}}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <!-- <img src="../assets/media/icons/png/shift-details/Area.png" alt="Area" height="20" /> -->
              <svg-icon class="svg_icon20x20 " src="assets/media/iq-svg/without_circle/icon_set_3/area.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control" [value]="shiftAllInfo?.area?.area_name" disabled />
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Location -->
      <div class="form-group w-100 col-sm-6">
        <label>{{masterBusinessLabel.Location}}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <!-- <img src="../assets/media/icons/png/shift-details/Location.png" alt="Location" height="20" /> -->
              <svg-icon class="svg_icon20x20 " src="assets/media/iq-svg/without_circle/icon_set_3/location.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control" [value]="shiftAllInfo?.location?.location_name" disabled />
        </div>
      </div>
      <!-- Client -->
      <div class="form-group w-100 col-sm-6">
        <label>{{masterBusinessLabel.Client}}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <!-- <img src="../assets/media/icons/png/shift-details/Client.png" alt="Client" height="20" /> -->
              <svg-icon class="svg_icon20x20 " src="assets/media/iq-svg/without_circle/icon_set_3/client.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control" [value]="shiftAllInfo.client?.client_name" disabled />
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Start Date & Time -->
      <div class="form-group w-100 col-sm-6">
        <label>Start Date & Time</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon23x20 " src="assets/media/iq-svg/without_circle/icon_set_5/start_date_&_time.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control" [value]="shiftAllInfo?.shift_start_date | LocationTimezoneDateTime : shiftInfo?.location?.location_fk_timezone_name"
            disabled />
          <!-- <textarea rows="2" class="form-control"
                    disabled>{{shiftAllInfo?.shiftStartDate | TimezoneDateTime}}</textarea> -->
        </div>
      </div>
      <!-- End Date & Time -->
      <div class="form-group w-100 col-sm-6">
        <label>End Date & Time</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon23x20 " src="assets/media/iq-svg/without_circle/icon_set_5/end_date_&_time.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control" [value]="(shiftAllInfo.shift_end_date | LocationTimezoneDateTime : shiftInfo?.location?.location_fk_timezone_name)" disabled />
          <!-- <textarea rows="2" class="form-control"
                    disabled>{{ (shiftAllInfo.shiftEndDate ? (shiftAllInfo?.shiftEndDate | TimezoneDateTime) : currentDate)}}</textarea> -->
        </div>
      </div>
    </div>




    <div class="row">
      <!-- Rest Break -->
      <div class="form-group w-100 col-sm-6">
        <label>Rest Break (Paid)</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <!-- <img src="../assets/media/icons/png/shift-details/RestBreak.png" alt="Client" height="20" /> -->
              <svg-icon class="svg_icon23x20 " src="assets/media/iq-svg/without_circle/icon_set_2/on_break.svg"></svg-icon>
            </span>
          </div>
          <textarea rows="2" class="form-control"
            disabled>{{shiftAllInfo.shift_total_paid_break_count}} Rest Break&#10;(Total {{shiftAllInfo?.shift_total_paid_break_time}} Min)</textarea>
        </div>
      </div>
      <!-- Meal Break -->
      <div class="form-group w-100 col-sm-6">
        <label>Meal Break(UnPaid)</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon23x20 " src="assets/media/iq-svg/without_circle/icon_set_5/meal_break.svg"></svg-icon>
            </span>
          </div>
          <textarea rows="2" class="form-control"
            disabled> {{shiftAllInfo.shift_total_unpaid_break_count}} Meal Break&#10;(Total {{shiftAllInfo?.shift_total_unpaid_break_time}} Min)</textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Total Shift Time -->
      <div class="form-group w-100 col-12">
        <label>Total Shift Time</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <!-- <img src="../assets/media/icons/png/shift-details/TotalTime.png" alt="Client" height="20" /> -->
              <svg-icon class="svg_icon20x20 " src="assets/media/iq-svg/without_circle/icon_set_1/my_timesheets.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control"
            [value]="mathRef.floor((shiftAllInfo.shift_actual_time/60)) + ' Hours ' + (shiftAllInfo.shift_actual_time % 60) + ' Minutes'"
            disabled />
        </div>
      </div>
    </div>


    <div class="row">
      <!-- Notes -->
      <div class="form-group w-100 col-12">
        <label>Shift Notes</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <!-- <img src="../assets/media/icons/png/shift-details/Notes.png" alt="Client" height="20" /> -->
              <svg-icon class="svg_icon20x20 " src="assets/media/iq-svg/without_circle/icon_set_4/notes.svg"></svg-icon>
            </span>
          </div>
          <input disabled type="text" class="form-control" [value]="shiftAllInfo?.shift_notes || ''" />
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #toShiftInfo>
  <div>
    <div class="row">
      <!-- Area -->
      <div class="form-group w-100 col-12">
        <label>{{masterBusinessLabel.Area}}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon20x20 " src="assets/media/iq-svg/without_circle/icon_set_3/area.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control" [value]="toShiftDetail?.area?.area_name" disabled />
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Location -->
      <div class="form-group w-100 col-sm-6">
        <label>{{masterBusinessLabel.Location}}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon20x20 " aria-label="My icon" src="assets/media/iq-svg/without_circle/icon_set_3/location.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control" [value]="toShiftDetail?.location?.location_name" disabled />
        </div>
      </div>
      <!-- Client -->
      <div class="form-group w-100 col-sm-6">
        <label>{{masterBusinessLabel.Client}}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon20x20 " src="assets/media/iq-svg/without_circle/icon_set_3/client.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control" [value]="toShiftDetail.client?.client_name" disabled />
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Start Date & Time -->
      <div class="form-group w-100 col-sm-6">
        <label>Start Date & Time</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon23x20 " src="assets/media/iq-svg/without_circle/icon_set_5/start_date_&_time.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control" [value]="toShiftDetail?.shift_start_date | TimezoneDateTime"
            disabled />
          <!-- <textarea rows="2" class="form-control"
                    disabled>{{toShiftDetail?.shiftStartDate | TimezoneDateTime}}</textarea> -->
        </div>
      </div>
      <!-- End Date & Time -->
      <div class="form-group w-100 col-sm-6">
        <label>End Date & Time</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon23x20 " src="assets/media/iq-svg/without_circle/icon_set_5/end_date_&_time.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control" [value]="(toShiftDetail.shift_end_date | TimezoneDateTime)"
            disabled />
          <!-- <textarea rows="2" class="form-control"
                    disabled>{{ (toShiftDetail.shiftEndDate ? (toShiftDetail?.shiftEndDate | TimezoneDateTime) : currentDate)}}</textarea> -->
        </div>
      </div>
    </div>




    <div class="row">
      <!-- Rest Break -->
      <div class="form-group w-100 col-sm-6">
        <label>Rest Break (Paid)</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon23x20 " src="assets/media/iq-svg/without_circle/icon_set_2/on_break.svg"></svg-icon>
            </span>
          </div>
          <textarea rows="2" class="form-control"
            disabled>{{toShiftDetail.shift_total_paid_break_count}} Rest Break&#10;(Total {{toShiftDetail?.shift_total_paid_break_time}} Min)</textarea>
        </div>
      </div>
      <!-- Meal Break -->
      <div class="form-group w-100 col-sm-6">
        <label>Meal Break(UnPaid)</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon23x20 " src="assets/media/iq-svg/without_circle/icon_set_5/meal_break.svg"></svg-icon>
            </span>
          </div>
          <textarea rows="2" class="form-control"
            disabled> {{toShiftDetail.shift_total_unpaid_break_count}} Meal Break&#10;(Total {{toShiftDetail?.shift_total_unpaid_break_time}} Min)</textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Total Shift Time -->
      <div class="form-group w-100 col-12">
        <label>Total Shift Time</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon20x20 " src="assets/media/iq-svg/without_circle/icon_set_1/my_timesheets.svg"></svg-icon>
            </span>
          </div>
          <input type="text" class="form-control"
            [value]="mathRef.floor((toShiftDetail.shift_actual_time/60)) + 'Hours' + (toShiftDetail.shift_actual_time % 60) + 'Minutes'"
            disabled />
        </div>
      </div>
    </div>


    <div class="row">
      <!-- Notes -->
      <div class="form-group w-100 col-12">
        <label>Notes</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text px-3 py-2">
              <svg-icon class="svg_icon20x20 " src="assets/media/iq-svg/without_circle/icon_set_4/notes.svg"></svg-icon>
            </span>
          </div>
          <input disabled type="text" class="form-control" [value]="toShiftDetail?.shift_notes || ''" />
        </div>
      </div>
    </div>
  </div>
</ng-template>